export const ALL_CHECKED_TEXT = { text: 'Todos selecionados', tooltipText: '' }
export const ONLY_CHECKED_TEXT = { text: 'Ver todos', tooltipText: 'Clique aqui para visualizar todas as opções' }
export const showOnlyCheckedDisabledText = (value?: number) => ({ text: `Ver selecionados: ${value ?? 0}`, tooltipText: 'Clique aqui para visualizar apenas as opções selecionadas' })
